export default "__VITE_ASSET__Dz2o0DTt__"